export const inputActions = {
  INPUT_BLUR: "input-blur",
  INPUT_CHANGE: "input-change",
  SET_VALUE: "set-value",
} as const;
